import { render, staticRenderFns } from "./planDeductionDc.vue?vue&type=template&id=246ac5de&scoped=true"
import script from "./planDeductionDc.vue?vue&type=script&lang=js"
export * from "./planDeductionDc.vue?vue&type=script&lang=js"
import style0 from "./planDeductionDc.vue?vue&type=style&index=0&id=246ac5de&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "246ac5de",
  null
  
)

export default component.exports